// extracted by mini-css-extract-plugin
module.exports = {"root":"EmptyCheck_root__1P5l2"};